// Sub Nav Open / close
var subNavToggle = function(){

    var breakPoint320   = 1023;
    var subNavSwitch    = $('.tv-js-header-navMainHasSub');
    var subNavContainer = $('.tv-header-navMainSub');

    if ($(window).width() > breakPoint320){

        subNavSwitch.hover(function(){
            $(this).find(subNavContainer).toggleClass('tv-header-navMainSub--open');
        });

    }

}

// Scroll to element
var goToEl = function() {
  var navLinks = $('.tv-landingHeader-link')

  navLinks.each(function() {
    $(this).on('click', function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $($(this).attr('href')).offset().top - 220
      }, 1000);
    });
  })
}

// Lang Open / close
// var langToggle = function(){

//     var langSwitch = $('.tv-js-header-navSecondaryLang');

//     langSwitch.hover(function(){
//         $(this).toggleClass('tv-header-navSecondaryLang--open');
//     });

// }

// Responsive Nav
var responsiveNav = function(){

    var breakPoint320    = 1023;
    var responsiveSwitch = $('.tv-js-header-navResponsiveSwitch');
    var responsiveClose  = $('.tv-js-header-navResponsiveClose');
    var navContainer     = $('.tv-header-nav');

    responsiveSwitch.on('click', function(){
        if ($(window).width() < breakPoint320){
            navContainer.addClass('tv-header-nav--open');
        }
    });

    responsiveClose.on('click', function(){
        if ($(window).width() < breakPoint320){
            navContainer.removeClass('tv-header-nav--open');
        }
    });

}

// Page arrow show / hide
var displayPageArrow = function(){

    if($('.tv-has-arrow').length){

        if($(window).scrollTop() < 80){
            $('.js-tv-page-arrow').show();
        } else{
            $('.js-tv-page-arrow').hide();
        }

        $(window).on('scroll', function (e){
            if($(window).scrollTop() < 80){
                $('.js-tv-page-arrow').fadeIn(600);
            } else{
                $('.js-tv-page-arrow').fadeOut(600);
            }
        });
    }

}

var toggleMenuMobile = function() {
  if($('.js-header__burger').length) {
    $(document).on('click', '.tv-header__burger-wrapper', function() {
      if (!$(this).find('.js-header__burger').hasClass('is-opened')) {
        $(this).find('.js-header__burger').addClass('is-opened');
        $('.tv-header__nav').css('display', 'flex');
        $('.tv-header__menu').css('display', 'flex');
        $('.tv-site-header').addClass('is-opened');
      } else {
        $(this).find('.js-header__burger').removeClass('is-opened');
        $('.tv-header__nav').hide();
        $('.tv-header__menu').hide();
        $('.tv-site-header').removeClass('is-opened');
      }
    })
  }
}

var toggleMaisons = function() {
  var breakPoint320   = 1023;

  if ($(window).width() >= breakPoint320) {
    $(document).on('keyup', '.tv-js-header', function(e) {
      e.preventDefault();

      if (e.key === 'Enter' || e.keyCode === 13) {
        $(this).next('.tv-menu__sublist-container').toggleClass('is-opened');
        $(this).next('.tv-menu__sublist-container').hasClass('is-opened') ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
      }
    })
  }


  if($('.js-header__burger').length) {
    $(document).on('click', '.tv-js-header', function(e) {
      if ($(window).width() < breakPoint320){
        e.preventDefault();
        $(".tv-menu__item .tv-menu__sublist-container").toggleClass('is-opened');
      }
    })
  }
}

$(document).ready(function(){
    subNavToggle();
    // langToggle();
    responsiveNav();
    displayPageArrow();
    goToEl();
    toggleMenuMobile();
    toggleMaisons();
});
